module.exports = __webpack_public_path__ + "img/fg.8c4a1f49.png";